import React from "react";
import Title_Section from "../../../components/Title_Section/Title_Section";
// import { useSelector } from "react-redux";
// import messages from "../../../assets/locale/messages";
import { useIntl } from "react-intl";

function DecksQuestions() {
  // const lang = useSelector((state) => state.locale.lang);
  const intl = useIntl();

  //   const entity = "Sub Topic";
  const message = intl.formatMessage(
    { id: "flashcard.subTopic.deleteMessage" },
    { entity: "Sub Topic" }
  );
  // const {
  //   flashCard: {
  //     subTopic: { title }
  //   }
  // } = messages[lang];
  return (
    <>
      <div className="d-flex align-items-center justify-content-between mb-4">
        <Title_Section title={"Decks"} />
        {message}
      </div>
    </>
  );
}

export default DecksQuestions;
